import { useState, useEffect } from 'react';
import { listTechnicians } from '../data/technicians';

/**
 * Técnicos do laboratório, para as telas de execução.
 *
 * Tolerante a falha de propósito: a lista alimenta um campo de quem executou o
 * procedimento. Se ela não carregar, o certo é a tela continuar servindo — a
 * sessão de OPU não pode parar porque o cadastro não respondeu.
 */
export const useTechnicians = (laboratoryId) => {
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!laboratoryId) { setTechnicians([]); return; }

    let cancelado = false;
    setLoading(true);
    listTechnicians(laboratoryId)
      .then(lista => { if (!cancelado) setTechnicians(lista || []); })
      .catch(err => {
        console.error('Erro ao carregar técnicos:', err);
        if (!cancelado) setTechnicians([]);
      })
      .finally(() => { if (!cancelado) setLoading(false); });

    return () => { cancelado = true; };
  }, [laboratoryId]);

  return { technicians, loading };
};

export default useTechnicians;
